// The selectable AI models are a vetted, database-driven list (the `ai_models` table). This only
// holds the default used when a company has no model set yet. Models are OpenRouter `provider/model`
// ids. Keep in sync with DEFAULT_MODEL in `supabase/functions/_shared/ai-models.ts`.

export const DEFAULT_AI_MODEL = 'openai/gpt-4o';
